import React, { useEffect, useState } from "react";
import { BookOpen, Users, MessageSquare, Star, FileText, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ courses: 0, students: 0, messages: 0, testimonials: 0, blog: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/courses").then(r => r.data.length).catch(() => 0),
      api.get("/admin/students").then(r => r.data.length).catch(() => 0),
      api.get("/admin/contact").then(r => r.data.length).catch(() => 0),
      api.get("/admin/testimonials").then(r => r.data.length).catch(() => 0),
      api.get("/admin/blog").then(r => r.data.length).catch(() => 0),
    ]).then(([courses, students, messages, testimonials, blog]) => {
      setStats({ courses, students, messages, testimonials, blog });
    });
  }, []);

  const cards = [
    { label: "Eğitimler", value: stats.courses, icon: BookOpen },
    { label: "Öğrenciler", value: stats.students, icon: Users },
    { label: "İletişim Mesajları", value: stats.messages, icon: MessageSquare },
    { label: "Yorumlar", value: stats.testimonials, icon: Star },
    { label: "Blog Yazıları", value: stats.blog, icon: FileText },
  ];

  return (
    <div>
      <span className="section-eyebrow">Genel Bakış</span>
      <h1 className="font-display text-4xl md:text-5xl mt-3 mb-2">Yönetim <span className="italic gold-gradient-text">paneli</span></h1>
      <p className="text-white/60 mb-10">Platformun mevcut durumunu buradan takip edin.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((c) => (
          <div key={c.label} data-testid={`stat-${c.label}`} className="bg-surface border border-white/10 p-6 card-hover">
            <c.icon className="w-6 h-6 text-gold mb-4" />
            <div className="font-display text-4xl">{c.value}</div>
            <div className="text-xs uppercase tracking-widest text-white/60 mt-2">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-surface border border-gold-30 p-8">
        <div className="flex items-center gap-3">
          <TrendingUp className="w-5 h-5 text-gold" />
          <div className="font-display text-xl">Hoş geldin, yönetici!</div>
        </div>
        <p className="text-white/70 mt-3 text-sm max-w-2xl">
          Sol menüden eğitim, blog ve yorumlar için tam CRUD yönetimi yapabilir, öğrenci kayıtlarını 
          görüntüleyebilir ve iletişim formu mesajlarını takip edebilirsiniz.
        </p>
      </div>
    </div>
  );
}
